

















































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
const cssPrefix = 'printLicenseDetails';
@Component({
  components:{
    ...UUIFComponent,
  },
  directives: {
    tooltip,
  },
})
export default class PrintLicenseDetailsSection extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  expiredServices: any;
  convertToTitleCase(value: string) {
    let values: string  = '';
    const val:any = value.toString()
                   .toLowerCase()
                   .split(' ');
    if (value) {
      val.forEach((element: any) => {
        values =  `${values}  ${element.charAt(0)
              .toUpperCase()}${element.slice(1)}`;
      });
      return values.trim();
    }
    return '';
  }
}
